import React from 'react';
import Footer from '../Footer';
import Header from '../Header';
import './style.css';

import PradeepImg from '../../assets/images/members/pradeep.jpg'
import AnupamImg from '../../assets/images/members/anupam.jpg'
import HarminderImg from '../../assets/images/members/harminder.jpg'
import CallToAction from '../CallToAction/CallToAction';


const Management = () => {

  let isLogin = localStorage.getItem('isLogin');
  const type = isLogin;

  return (
    <div className="Management">
      <Header type={type} />

      <section className='admn-team'>
        <div className='container'>
          <div className="row">
            <div className='col-sm-12'>
              <h2 className='admn-team__heading'>Management Team</h2>
            </div>
            <div className='col-sm-12 col-lg-4 mb-3 mb-lg-3'>
              <figure className='admn-team__avatar'>
                <img src={PradeepImg} alt="team member" />
              </figure>
              <h3>Pradeep Narayanan</h3>
              <h4>MANAGING DIRECTOR</h4>
              <p>Pradeep is the founder of Admizzionz Campuz® and brings with him a vast experience of over 40 years in education, corporate training, IT services and BPO. He is an acknowledged expert in Career and College Admissions in India. He has been the anchor speaker for the Mission Admission program of Times of India and features as a career and college admission expert on All India Radio and FM Radio Fever 104 for talk shows. Through these and other media he has addressed audiences of over 50,000 students and parents on various careers as well as course and college opportunities in India.</p>
              <p>Pradeep has done his post-graduation in management from XLRI, Jamshedpur, one of India’s prestigious management schools.</p>
            </div>
            <div className='col-sm-12 col-lg-4 mb-3 mb-lg-3'>
              <figure className='admn-team__avatar'>
                <img src={AnupamImg} alt="team member" />
              </figure>
              <h3>Anupam Srivastava</h3>
              <h4>EXECUTIVE DIRECTOR</h4>
              <p>As the Executive Director of Admizzionz Campuz®, Anupam leads its technology, marketing and, product development. He has been instrumental in the design and development of various psychometric assessments and related service offerings of Admizzionz Campuz . He brings with him over 35 years of experience in corporate training, e-learning, consulting, software services domains. During his career he has worked extensively in Japan and Europe with NIIT and Infopro Learning.</p>
              <p>Anupam is a graduate in chemical engineering from IIT, Delhi and a post graduate in finance & marketing from the IIM, Bangalore.</p>
            </div>
            <div className='col-sm-12 col-lg-4'>
              <figure className='admn-team__avatar'>
                <img src={HarminderImg} alt="team member" />
              </figure>
              <h3>Harminder Kaur</h3>
              <h4>DIRECTOR - SERVICE DELIVERY</h4>
              <p>As the Director – Service Delivery, Harminder focusses on ensuring service culture, service quality, customer experience and advisor’s engagement in delivering the service offerings of Admizzionz Campuz. She plays a major role in defining and executing policies and processes and guiding various teams in implementing them.</p>
              <p>She is a certified career counsellor and a visiting counsellor at several schools as a part of the counsellor at school initiative of Admizzionz Campuz®️. She conducts sessions on “Subject Linkages to Careers”, “College Admissions in India – Opportunities & Challenges” amongst many others at various schools and other forums. Has been involved in building psychometric tools for Career Interest Profiling and Multiple Intelligences.</p>
              <p>Harminder is a Bachelor’s of Science from University of Delhi and B.Ed. in Special Education.</p>
            </div>
          </div>
        </div>
      </section>

      <CallToAction />

      <Footer />
    </div>
  )
}

export default Management



/** WEBPACK FOOTER **
 ** ./src/components/Management/index.js
 **/